import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agecalculate'
})
export class AgecalculatePipe implements PipeTransform {

  transform(value: any): any {
    let age = Math.floor((+new Date() - new Date(value).getTime()) / 3.15576e+10);
    console.log(value);
    if (value == false) {
      return false
    }
    if (age < 13) {
      return false;
    } else {
      return true;
    }

  }

}
